import { gql } from '@apollo/client';

import { theGraphAniftyERC1155Client } from '@/apis/theGraph/theGraphClients';

/**
 * The Graph Subgraph Client for ERC1155 token v1
 */

export const getTokenInfoByID = async (
  tokenID: string | number
): Promise<{
  aniftyTokens: {
    id: string;
    creationTime: string;
    tokenId: string;
    totalTokenAmount: string;
    creatorName: string;
    description: string;
    imageUrl: string;
    tokenName: string;
    owners: {
      owner: {
        address: string;
      };
      tokenAmount: string;
    }[];
  }[];
}> => {
  const query = `
    {
        aniftyTokens(where: {tokenId: "${tokenID}"}) {
            id
            creationTime
            tokenId
            totalTokenAmount
            creatorName
            description
            imageUrl
            tokenName
            owners {
                owner {
                    address
                }
                tokenAmount
            }
        }
    }
    `;

  const response = await theGraphAniftyERC1155Client.query({
    query: gql(query),
  });

  return response.data;
};

export const getOwnerInfoByAddress = async (
  ownerAddress: string
): Promise<{
  owners: {
    __typename: string;
    id: string;
    address: string;
    tokens: {
      __typename: string;
      id: string;
      token: {
        __typename: string;
        id: string;
        creationTime: string;
        tokenId: string;
        totalTokenAmount: string;
        creatorName: string;
        description: string;
        imageUrl: string;
        tokenName: string;
      };
      tokenAmount: string;
    }[];
  }[];
}> => {
  const query = `
    {
        owners(where: {address: "${ownerAddress}"}) {
            id
            address
            tokens {
                id
                token {
                    id
                    creationTime
                    tokenId
                    totalTokenAmount
                    creatorName
                    description
                    imageUrl
                    tokenName
                }
                tokenAmount
            }
        }
    }
    `;

  const response = await theGraphAniftyERC1155Client.query({
    query: gql(query),
  });

  return response.data;
};
